<template>
  <div>
    <yxt-row
      type="flex"
      class="yxtbiz-shop-selector-area-container yxtbiz-shop-selector-area-multi-container"
    >
      <div class="yxtbiz-shop-search-wrap mb16">
        <ShopClassifySelector
          clearable
          filterable
          style="width: 160px;"
          :placeholder="'pc_biz_shoptour_select_cate_top'"
          @change="onCatalogChange"
        />
        <yxt-input
          v-model.trim="shopValue"
          :placeholder="
            $t(
              'pc_biz_shoptour_search_shop_placeholder' /* 请输入门店名称模糊搜索 */
            )
          "
          class="ml12"
          style="width: 240px;"
          searchable
          @search="searchShop"
        />
        <div class="yxtbiz-shop-withdrawn flex-1"><yxt-checkbox  :true-label="1" :false-label="0" v-model="params.containRevoke">{{ $t('pc_biz_shoptour_show_withdrawn' /*显示撤回发布门店*/) }}</yxt-checkbox></div>
      </div>

      <yxt-table
        ref="shopTable"
        :key="'shops' + timeStamp"
        v-loading="loading"
        :height="tableHeight"
        class="yxtbiz-shop-table"
        :data="shops"
        @select-all="selectAllShop"
        @select="selectShop"
      >
        <template slot="empty">
          <div style="line-height: normal;">
            <yxt-empty />
          </div>
        </template>
        <yxt-table-column
          :show-overflow-tooltip="false"
          class-name="yxtbiz-shop-table-selection"
          type="selection"
          width="40"
        />
        <yxt-table-column
          :label="$t('pc_biz_shoptour_shop_name' /* 门店名称 */)"
          :show-overflow-tooltip="true"
          prop="storeName"
          min-width="200"
        />
        <yxt-table-column
          :label="$t('pc_biz_shoptour_belong_area' /* 所属区域 */)"
          :show-overflow-tooltip="true"
          prop="areaName"
          min-width="350"
        >
          <template slot-scope="scope">
            {{ scope.row.areaName || '--' }}
          </template>
        </yxt-table-column>
      </yxt-table>
      <yxt-row align="middle" class="yxtbiz-shop-selector-mask mt16" type="flex">
        <yxt-row type="flex" align="middle" class="col-flex-1">
          <yxt-button
            v-if="showFilterAll"
            type="text"
            class="lh32 yxtbiz-shop-btn-search-all"
            :class="isSearchAll ? 'color-primary-4 disabled' : ''"
            @click="searchAll"
          >
            {{
              isCancelSelect
                ? $t('pc_biz_shoptour_btn_cancelFilter' /*取消筛选结果*/)
                : $t('pc_biz_shoptour_all_filter_results' /*全选筛选结果*/)
            }}
          </yxt-button>
          <div v-loading="isSearchAll" class="yxtbiz-shop-loading__all" />
        </yxt-row>
        <yxt-pagination
          :current-page.sync="page"
          :page-size="params.limit"
          simple-total
          layout="total, prev, pager, next"
          :total="count"
          :pager-count="5"
          @size-change="sizeChange"
          @current-change="pageChange"
        />
      </yxt-row>
    </yxt-row>
  </div>
</template>
<script>
import { getStoreSearchList } from '../service';
import ShopClassifySelector from './shopClassifySelector';
import resizeTable from './mixins/resizeTable';
export default {
  name: 'Area',
  components: {
    ShopClassifySelector
  },
  mixins: [resizeTable],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      refTable: 'shopTable',
      isSearchAll: false,
      storeCatalogId: '', // 分类
      shopValue: '', //
      page: 1,
      count: 0,
      tableHeight: 0,
      params: {
        // 搜索条件
        storeCatalogId: '',
        storeName: '',
        limit: 20,
        offset: 0,
        deepSearch: 1,
        containRevoke: 0
      },
      isCancelSelect: false,
      showFilterAll: true, // 是否显示筛选所有
      loading: true,
      shops: [],
      selectedShops: {},
      timeStamp: ''
    };
  },
  watch: {
    value(v) {
      this.formatShops(v);
      this.checkStatus();
    },
    shops() {
      this.timeStamp = new Date().valueOf();
    }
  },
  created() {
    this.getStoreList();
    // 选中数组转化为对象，方便查找
    this.formatShops(this.value);
  },
  methods: {
    // 转化已选门店数据
    formatShops(shops) {
      this.selectedShops = {};
      shops.forEach((item) => {
        this.selectedShops[item.storeId] = item;
      });
    },
    // 获取门店列表
    getStoreList() {
      this.loading = true;
      this.isCancelSelect = false;
      getStoreSearchList(this.params)
        .then((result) => {
          if (
            result.datas.length !== 0 &&
            (this.params.storeName.trim() !== '' ||
              this.params.storeCatalogId !== '')
          ) {
            // 搜索条件不为空，展示筛选全部按钮
            this.showFilterAll = true;
          } else {
            this.showFilterAll = false;
          }
          this.shops = result.datas;
          this.count = result.paging.count;
          this.loading = false;
          this.$nextTick(() => {
            this.checkStatus();
          });
        })
        .catch((e) => {
          this.shops = [];
          this.loading = false;
        });
    },
    // 门店分类变更
    onCatalogChange(id) {
      this.storeCatalogId = id;
      this.searchShop();
    },
    // 搜索
    searchShop() {
      this.params.storeName = this.shopValue;
      this.params.storeCatalogId = this.storeCatalogId;
      this.params.offset = 0;
      this.page = 1;
      this.getStoreList();
    },
    // 取消全部筛选结果
    cancelSelectAll() {
      // 此处获取全量数据
      getStoreSearchList(
        Object.assign({}, this.params, { offset: 0, limit: this.count })
      ).then((res) => {
        this.isCancelSelect = false;
        const list = res.datas;
        list.forEach((shop) => {
          delete this.selectedShops[shop.storeId];
        });
        this.updateShop(list, false);
      });
    },
    searchAll() {
      if (this.isCancelSelect) {
        // 取消全部筛选结果
        return this.cancelSelectAll();
      }
      const limitCount = 5000;
      const len = Math.ceil(this.count / limitCount);
      let count = 0;
      let postData = Object.assign({}, this.params, { limit: limitCount });
      if (len > 0) {
        this.isSearchAll = true;
      }
      // 分批请求门店数据
      for (let i = 0; i < len; i++) {
        getStoreSearchList(
          Object.assign({}, postData, { offset: limitCount * i })
        )
          .then((result) => {
            count++;
            if (count >= len) {
              this.isSearchAll = false;
              this.isCancelSelect = true;
            }
            const list = result.datas;
            list.forEach((shop) => {
              this.selectedShops[shop.storeId] = shop;
            });

            this.updateShop(list, true);
          })
          .catch((e) => {
            this.isSearchAll = false;
            this.$message({
              type: 'error',
              message: e
            });
          });
      }
    },
    // 分页条数改变
    sizeChange(size) {
      this.params.limit = size;
      this.page = 1;
      this.params.offset = 0;
      this.getStoreList();
    },
    // 页码改变
    pageChange(page) {
      this.page = page;
      this.params.offset = (page - 1) * this.params.limit;
      this.getStoreList();
    },
    // 勾选或取消勾选门店
    selectShop(selection, row) {
      let isAdd = selection.some((v) => {
        return v.storeId === row.storeId;
      });
      if (isAdd) {
        this.selectedShops[row.storeId] = row;
      } else {
        delete this.selectedShops[row.storeId];
      }
      this.updateShop(row, isAdd);
    },
    // 触发选中人员更新
    updateShop(items, isAdd) {
      this.$emit('input', Object.values(this.selectedShops));
      this.$emit('update', items, isAdd);
    },
    // 勾选或取消当前页的全选
    selectAllShop(selection) {
      let isAdd = selection.length !== 0;
      this.shops.forEach((shop) => {
        if (!isAdd) {
          delete this.selectedShops[shop.storeId];
        } else {
          this.selectedShops[shop.storeId] = shop;
        }
      });

      this.updateShop(this.shops, isAdd);
    },
    // 验证是否选中
    checkStatus() {
      if (this.value.length === 0) {
        this.isCancelSelect = false;
        this.$refs['shopTable'].clearSelection();
      } else {
        this.shops.forEach((shop) => {
          if (this.selectedShops.hasOwnProperty(shop.storeId)) {
            this.$refs['shopTable'].toggleRowSelection(shop, true);
          } else {
            this.$refs['shopTable'].toggleRowSelection(shop, false);
          }
        });
      }
    }
  }
};
</script>
